/*
 *
 * PayToCardPopup
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 02-Oct-2026
 */

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as userActions from 'Store/actions/user'
import { userPermissions } from 'Store/selectors'
import { doPopup } from 'Store/actions/popup'
import PayToCardPopup from './PayToCardPopup'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(userActions, dispatch),
  closePopup: () => dispatch(doPopup(''))
})

const mapStateToProps = (state) => ({
  data: state?.popup?.popupData || {},
  userPermissions: userPermissions(state),
  isUpdatingVas: state?.loading?.local_manageVas || false
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(PayToCardPopup)
